import { render, staticRenderFns } from "./TradingTradesExtra.vue?vue&type=template&id=4ca2192c&scoped=true&"
import script from "./TradingTradesExtra.vue?vue&type=script&lang=js&"
export * from "./TradingTradesExtra.vue?vue&type=script&lang=js&"
import style0 from "./TradingTradesExtra.vue?vue&type=style&index=0&id=4ca2192c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca2192c",
  null
  
)

export default component.exports